module.exports = __webpack_public_path__ + "static/endlesssshape-fdad4248bf62aaba2bf8a03252a0d2e4.png";